import React from 'react';


import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';


import Toolbar from '@material-ui/core/Toolbar';

import Grid from '@material-ui/core/Grid';

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:{
    color: theme.palette.primary.main,
    backgroundImage: 'linear-gradient(90deg, rgba(117,74,103,0.396796218487395) 0%, rgba(72,51,65,0.41360294117647056), rgba(30,25,25,0.396796218487395) 100%)',
    boxShadow: theme.shadows[5],
  },
  title: {
    flex: '1 1 100%',
  },
  invetoryIcons: {
    flex: '1 1 30%',
  },
  invetorySpace: {
    width: '50px'
  }
}));

const ComponentToolbar = ({ children, title }) => {
  const classes = useToolbarStyles();


  return (
    <React.Fragment>
      <Toolbar className={classes.highlight}>
        <Typography
          className={classes.title}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {title}
        </Typography>

        <Grid
          container
          direction="row"
          justify="flex-end"
          alignItems="center"
          spacing={2}
        >
          {children}
        </Grid>
      </Toolbar>
    </React.Fragment>
  );
}

export default ComponentToolbar;